import { Component, EventEmitter, Output,  ChangeDetectionStrategy, InputSignal, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Restaurant } from '../../core/interfaces/establishments/establishment.interface';
import { EstablishmentIsOpenService } from '../../core/service/estasblishment-is-open.service';
import { LoadImagesService } from '../../core/service/load-image.service';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { trigger, transition, style, animate } from '@angular/animations';
import { EstablishmentsForCategorieData } from '../establishments-for-categorie/interface/establishments-for-categorie.interface';
import { FavoriteEstablihshmentComponent } from './components/favorite-establihshment/favorite-establihshment.component';
import { IsOpen } from '../../shared/directives/isOpen';

@Component({
  selector: 'features-establishemnts-general',
  standalone: true,
  imports: [CommonModule, NgxSkeletonLoaderModule, FavoriteEstablihshmentComponent, IsOpen],
  templateUrl: './establishemnts-general.component.html',
  styleUrl: './establishemnts-general.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms ease-in', style({ opacity: 1 }))
      ])
    ])
  ]
})
export class EstablishemntsGeneralComponent {
  establishments: InputSignal<EstablishmentsForCategorieData[]> = input.required<EstablishmentsForCategorieData[]>();
  isLoading: InputSignal<boolean> = input.required<boolean>();
  @Output() visitClick = new EventEmitter<{
    id_restaurant: number,
    name_restaurant: string
  }>();
  // Default restaurant if no data is passed
  restaurant: Restaurant = {
    id_restaurant: 1,
    name_restaurant: 'La Bella Italia',
    address: 'Downtown Food District',
    picture_logo: 'assets/restaurant.jpg',
    apertura: '11:00',
    cierre: '22:00',
    isOpen: '1',
    tags: ['Italian', 'Pasta', 'Pizza']
  };

  isOpen = false;
  readonly defaultImage = 'assets/imagen_default.png';

  constructor(
    private establishmentService: EstablishmentIsOpenService,
    private loadImageService: LoadImagesService
  ) { }



  formatTime(time: string | undefined): string {
    return this.establishmentService.formatTime(time);
  }
  /**
   * Gets the full image URL with the base URL from the LoadImagesService
   * If the image path is empty or invalid, returns the default image
   */
  getImageUrl(imagePath: string | undefined): string {
    // If no image path is provided, return default image immediately
    if (!imagePath) {
      return this.defaultImage;
    }

    // Check if the image path is already a full URL or an asset path
    if (imagePath.startsWith('http') || imagePath.startsWith('assets/')) {
      return imagePath;
    }

    // Return the full path with the base URL
    return this.loadImageService.linkImage + imagePath;
  }

  onVisitClick(establishment: EstablishmentsForCategorieData): void {
    this.visitClick.emit({
      id_restaurant: establishment.id_restaurant,
      name_restaurant: establishment.name_restaurant
    });
  }

  onImageError(event: any): void {
    event.target.src = this.defaultImage;
  }

  isRestaurantOpen(establishment: EstablishmentsForCategorieData): boolean {
    if (!establishment.apertura || !establishment.cierre) {
      return false;
    }
    // Convert boolean to string for the service method
    const isOpenString = establishment.isOpen ? true : false;
    return this.establishmentService.isEstablishmentOpen(
      establishment.apertura,
      establishment.cierre,
      isOpenString
    );
  }

  onFavoriteToggled(establishment: EstablishmentsForCategorieData, isFavorite: boolean): void {
    establishment.isFavorite = isFavorite;
  }

  formatDistance(distance: number): string {
    if (distance >= 1000) {
      return (distance / 1000).toFixed(1) + ' km';
    }
    return Math.round(distance) + ' m';
  }

  formatRating(rating: number | null | undefined): string {
    if (rating === null || rating === undefined || rating === 0) {
      return 'Sin calificaciones';
    }
    return rating.toFixed(1);
  }

  getStarRating(rating: number | null | undefined): number {
    if (!rating) {
      return 0;
    }
    return Math.floor(rating);
  }

  isHalfStar(star: number, rating: number | null | undefined): boolean {
    if (!rating) {
      return false;
    }
    const floorRating = Math.floor(rating);
    const hasDecimal = rating % 1 >= 0.5;
    return star === floorRating + 1 && hasDecimal;
  }

  isEmptyStar(star: number, rating: number | null | undefined): boolean {
    if (!rating) {
      return true;
    }
    return star > rating;
  }

  isEnableEstablishment(creditos: number): boolean {
    if (creditos < 60) {
      return false;
    }
    return true;
  }


  isInRange(isInRange: boolean): boolean {
    return isInRange;
  }

}
